const monthData = {
  data: [
    "Today",
    "January",
    "Febraruy",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};

const yearData = [
  "2018",
  "2019",
  "2020",
  "2021",
  "2022",
  "2023",
  "2024",
  "2025"
];

const fileTypes = [
  {
    value: "agent",
    name: "Agent"
  },
  {
    value: "landlords",
    name: "Landlords"
  },
  {
    value: "trucker",
    name: "Trucker"
  },
  {
    value: "general",
    name: "Small Business"
  },
  {
    value: "freelancers",
    name: "Freelancers"
  }
];
module.exports = {
  monthData,
  yearData,
  fileTypes
};



// WEBPACK FOOTER //
// ./src/variables/data.jsx